import { render, staticRenderFns } from "./QuestionMultiSelect.vue?vue&type=template&id=6b37ec89&"
import script from "./QuestionMultiSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports